import React from 'react';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-5 text-center text-muted small">
      Copyright © {year} <a href="https://outreach.bettertrucks.com" target="_blank" rel="noopener noreferrer">Better Trucks Outreach Portal</a>. All rights reserved.
    </footer>
  );
}

export default Footer; 